const MENU_COLLAPSE_KEY = 'apm_menu_collapse';

const analyze = {
  namespaced: true,
  state: {
    collapse: localStorage.getItem(MENU_COLLAPSE_KEY) === 'true',
  },
  getters: {
    collapse: (state) => state.collapse,
  },
  actions: {
    /**
     * 设置平台列表
     */
    setCollapse({ commit }, collapse) {
      localStorage.setItem(MENU_COLLAPSE_KEY, collapse);
      commit('SET_COLLAPSE', collapse);
    },
  },
  mutations: {
    SET_COLLAPSE: (state, collapse) => {
      state.collapse = collapse;
    },
  },
};

export default analyze;
